"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DiscoverRightHeader;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const store_1 = require("../../store");
const user_1 = require("../../store/selectors/user");
const useAppQuota_1 = require("../../hooks/useAppQuota");
const ProfileIcon_1 = __importDefault(require("../ProfileIcon"));
const react_native_2 = require("react-native");
const AppButton_1 = require("../AppButton");
const native_1 = require("@react-navigation/native");
const CreditCounter_1 = __importDefault(require("../../navigation/CreditCounter"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const constants_1 = require("../../common/constants");
function DiscoverRightHeader({ search, style, ...restProps }) {
    const dispatch = (0, store_1.useAppDispatch)();
    const { pendingCharacterCount, pendingMessageCount } = (0, useAppQuota_1.useAppQuota)();
    const fbUserId = (0, react_redux_1.useSelector)(user_1.selectfbUserId);
    const navigation = (0, native_1.useNavigation)();
    const userIsLogged = (0, react_1.useMemo)(() => (Boolean(fbUserId)), [fbUserId]);
    const handleLoginPress = () => {
        navigation.navigate('LoginPage');
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [{
                flexDirection: 'row',
                alignItems: 'center',
                gap: 8,
            }, style], ...restProps, children: userIsLogged ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [pendingCharacterCount <= constants_1.WARNING_CHARACTER_QUOTA
                    && pendingMessageCount <= constants_1.WARNING_MESSAGES_QUOTA
                    && ((0, jsx_runtime_1.jsx)(CreditCounter_1.default, {})), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => navigation.navigate('Search'), children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSearch, color: "white", size: 24 }) }), (0, jsx_runtime_1.jsx)(ProfileIcon_1.default, { style: styles.profileIcon })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [pendingCharacterCount <= constants_1.WARNING_CHARACTER_QUOTA
                    && pendingMessageCount <= constants_1.WARNING_MESSAGES_QUOTA
                    && ((0, jsx_runtime_1.jsx)(CreditCounter_1.default, {})), (0, jsx_runtime_1.jsx)(AppButton_1.PrimaryButton, { onPress: handleLoginPress, children: "Login" }), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => navigation.navigate('Search'), children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSearch, color: "white", size: 24 }) }), (0, jsx_runtime_1.jsx)(ProfileIcon_1.default, { style: styles.profileIcon })] })) }));
}
;
const styles = react_native_2.StyleSheet.create({
    profileIcon: {
        marginLeft: 24,
    },
});
